<script>
  export let id = '';
  export let label = '';
  export let hint = '';
  export let error = '';
  export let className = '';
</script>

<label for={id} class={`block min-w-0 ${className}`}>
  {#if label}
    <span class="mb-1.5 block text-sm font-medium text-slate-700">{label}</span>
  {/if}

  <slot />

  {#if hint}
    <p class="mt-1.5 text-xs leading-relaxed text-slate-500">{hint}</p>
  {/if}

  {#if error}
    <p class="mt-1.5 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>
  {/if}
</label>
